export enum OpportunityMemberTypeEnum {
  CUSTOMER = 'customer',
  VENDOR = 'vendor',
  CLOUD = 'cloud',
}
